import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';

export type EntityResponseType = HttpResponse<any>;
export type EntityArrayResponseType = HttpResponse<any[]>;

@Injectable({ providedIn: 'root' })
export class FileRepositoryService {
  protected resourceUrl = `${environment.SERVER_EDITION_API_URL}/api/editions/download`;

  constructor(protected http: HttpClient) {}

  getFile(id: number): Observable<any> {
    return this.http.post<any>(`${this.resourceUrl}/${id}`, { responseType: 'blob', observe: 'response' }).pipe(
      map((response) => {
        // Handle the file download
        const blob = response.body!;

        // const fileName = response.headers.get(
        //   'Filename'
        // );
        // saveAs(blob, fileName);

        return { fileRepositoryFile: blob };
      })
    );
  }

  // generateReport(
  //     queryName: string,
  //     queryParam: QueryParamDTO
  //   ): Observable<Blob> {
  //     // Single endpoint URL - no format in path
  //     const url = `${this.reportsUrl}/generate/${queryName}`;

  //     // Set headers dynamically based on isDocx signal
  //     const headers = new HttpHeaders({
  //       'X-Is-Docx': this.isDocx().toString(),
  //     });

  //     return this.http
  //       .post(url, queryParam, {
  //         headers,
  //         responseType: 'blob',
  //         observe: 'response',
  //       })
  //       .pipe(
  //         map((response) => {
  //           // Handle the file download
  //           const blob = response.body!;

  //           const fileName = response.headers.get(
  //             'Filename'
  //           );
  //           saveAs(blob, fileName);

  //           return blob;
  //         })
  //       );
  //   }
}
